export default "__VITE_ASSET__dadfe183__"